import { ActionIcon, LoadingOverlay, Modal } from "@mantine/core";
import React from "react";
import { Trash } from "react-feather";
import Button from "../Various/Button";

function Delete({
  onConfirm,
  entityType,
  entityName,
  isLoading,
  children,
}: {
  onConfirm: () => void;
  entityType: string;
  entityName: string;
  isLoading: boolean;
  children?: React.ReactNode;
}) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <ActionIcon
        className="text-red-600"
        onClick={() => {
          setIsModalOpen(true);
        }}
        title={`${entityType} löschen`}
      >
        <Trash size={12} />
      </ActionIcon>

      <LoadingOverlay visible={isLoading} />

      <Modal
        centered
        opened={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={<h2 className="font-bold text-xl">{entityType} löschen</h2>}
      >
        Sind Sie sicher, dass Sie den {entityType} &quot;{entityName}&quot;
        löschen möchten? Dieser Vorgang kann nicht rückgängig gemacht werden.
        {children}
        <div className="mt-6 flex">
          <Button
            onClick={() => setIsModalOpen(false)}
            variant="subtle"
            className="w-full p-2"
          >
            Abbrechen
          </Button>
          <Button
            onClick={() => {
              setIsModalOpen(false);
              onConfirm();
            }}
            variant="subtle"
            color="red"
            className="w-full p-2"
          >
            {entityType} löschen
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default Delete;
